import { render, staticRenderFns } from "./RolModal.vue?vue&type=template&id=cb0aa62e"
import script from "./RolModal.vue?vue&type=script&lang=js"
export * from "./RolModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports